
import { Users, BookOpen, GraduationCap, Star } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const InfoBanners = () => {
  const { t } = useTranslation();

  const stats = [
    {
      icon: Users,
      number: '15,000+',
      label: t('info.students')
    },
    {
      icon: BookOpen,
      number: '250+',
      label: t('info.courses')
    },
    {
      icon: GraduationCap,
      number: '50+',
      label: t('info.instructors')
    },
    {
      icon: Star,
      number: '98%',
      label: t('info.satisfaction')
    }
  ];

  return (
    <section className="py-16 bg-teal-600">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {stats.map((stat, index) => {
            const IconComponent = stat.icon;
            return (
              <div key={index} className="text-center text-white">
                <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
                  <IconComponent className="w-8 h-8 text-white" />
                </div>
                <div className="text-3xl font-bold mb-2">{stat.number}</div>
                <div className="text-teal-100">{stat.label}</div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default InfoBanners;
